<template>
    <div class="student-modal">
      <div class="student-title">
        <span class="student-title__text">班级名单</span>
        <span class="student-title__count">{{ studentList.length || 0 }} 人</span>
      </div>
      <div class="tips-bar">
        <i class="iconfont a-jingshigantanhao"></i>
        <span>如需指定人员参与，请点选下方具体人员即可</span>
      </div>

      <ul class="student-list">
        <li v-for="item in studentList" :key="item.id" class="student-card"
          :class="{ 'student-card--active': activeStudentId === item.id }" @click="onSelect(item)">
          <img class="student-avatar" :src="item.photo" alt="">

          <div class="student-main">
            <div class="student-name">{{ item.name || '--' }}</div>
            <p class="student-meta">
              <span class="stuIden">SID:{{ item.id || '--' }}</span>
              <span class="stuIden line1" >学号:{{ item.studentNo || '--' }}</span>
            </p>
          </div>
            <div
              class="student-score"
              :class="`student-score--${(scoreSets[item.id]?.levelWord || '').toLowerCase()}`"
              v-show="scoreSets[item.id]?.levelWord"
              @click.stop="$emit('openReport',item.id)"
            >
              <span class="student-level">{{ scoreSets[item.id]?.levelWord || '' }}</span>
              <span class="student-points">{{ scoreSets[item.id]?.overall || '' }}</span>
            </div>

            <i class="iconfont gengduo student-arrow"></i>
        </li>
      </ul>
    </div>
</template>

<script>
export default {
  name: 'Students',
  props: {
    scoreSets: {
      type: Object,
      default () {
        return {}
      }
    },
    selectedStudentId: {
      type: [String, Number, null],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userStatus: false,
      studentList: [],
      activeStudentId: null
    }
  },
  mounted() {
    this.loadList()
  },
  watch: {
    selectedStudentId: {
      immediate: true,
      handler(val) {
        this.activeStudentId = val || ''
      }
    }
  },
  methods: {
    onSelect(item) {
      if(this.disabled)return
      this.activeStudentId = this.activeStudentId == item.id ? null : item.id
      this.$emit('onSelect',{
        ...item,
        stdId: this.activeStudentId,
      })
    },
    getStudentLevel(item = {}) {
      return item.level || item.gradeLevel || item.rankLevel || item.rank || 'A'
    },
    getStudentScore(item = {}) {
      const score = item.score ?? item.totalScore ?? item.points ?? item.integral
      return score !== undefined && score !== null && score !== '' ? `${score} 分` : '-- 分'
    },
    // 学生、老师列表
    async loadList() {
      this.userStatus = true
      this.activeStudentId = this.selectedStudentId || ''

      try {
        const res = await this.$post('/classes/teacherAndStudentList.json', {
          classesId: this.$route.query.classesId,
        })
        this.studentList = (res && res.data && res.data.studentList) || []
        // this.activeStudentId = this.studentList[0] && this.studentList[0].id || null
      } catch (error) {

      }
    }
  }
}
</script>

<style scoped lang="less">
.student-modal {
  padding: 6px 20px 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.student-title {
  display: flex;
  align-items: center;
  margin: 16px 0;
  padding-left: 16px;
  color: #333333;
  position: relative;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border: 2px solid #FB7C33;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    box-sizing: border-box;
  }
}

.student-title__text {
  font-size: 20px;
  line-height: 27px;
  font-weight: 700;
}

.student-title__count {
  margin-left: 12px;
  font-size: 20px;
  line-height: 27px;
  font-weight: 600;
}

.tips-bar {
  width: 362px;
  height: 25px;
  background: #FEFAF2;
  font-size: 12px;
  color: #333333;
  display: flex;
  align-items: center;
  padding: 0 12px;
  margin: -8px 0 16px;


  .iconfont {
    font-size: 18px;
    color: #666;
    margin-right: 10px;
  }
}

.student-list {
  flex: 1;
  overflow-y: auto;
  padding-right: 4px;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    background: transparent;
  }
}

.student-card {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 18px 20px;
  border: 1px solid #999;
  border-radius: 10px;
  transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;
  cursor: pointer;

  &:hover,
  &--active {
    box-shadow: 0px 16px 18px -5px rgba(0, 0, 0, 0.06);
    border: 2px solid #FB7C33;
  }
}

.student-avatar {
  width: 49px;
  height: 49px;
  flex-shrink: 0;
  margin-right: 16px;
  border-radius: 50%;
  object-fit: cover;
}

.student-main {
  flex: 1;
  min-width: 0;
}

.student-name {
  color: #333;
  font-size: 20px;
  font-weight: 700;
}

.student-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

.stuIden {
  max-width: 100px;
  min-width: 50px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #DDDDDD;
  font-size: 10px;
  color: #666666;
  padding: 0 4px;
}

.student-score {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // min-width: 84px;
  margin: 0 10px 0 14px;

  &.student-score--a {
    color: #00b40a;
  }

  &.student-score--b {
    color: #038bea;
  }

  &.student-score--c {
    color: #ffac00;
  }

  &.student-score--d {
    color: #ff5c5c;
  }
}

.student-level {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}

.student-points {
  margin-top: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

.student-arrow {
  flex-shrink: 0;
  font-size: 16px;
}
</style>
